<div class="action-with-confirmation-text">
  <app-popup-top-line></app-popup-top-line>
  <div class="action-with-confirmation-text-header">
    <div class="title">{{ getTitle() }}: {{ data.itemName }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="cancelClicked()" />
  </div>
  <div class="action-with-confirmation-text-body">
    <div class="confirmation-text">
      To confirm {{ getConfirmationAction() }}, type <em>{{ getConfirmationText() }}</em> in the text input field.
    </div>
    <div
      class="input"
      [ngClass]="{
        'search-invalid':
          textValidationControl.invalid && (textValidationControl.dirty || textValidationControl.touched),
      }"
    >
      <input
        class="search-input"
        type="text"
        [formControl]="textValidationControl"
        placeholder="{{ getConfirmationText() }}"
      />
    </div>
    <div class="disclaimer" *ngIf="disclaimer">{{ getDisclaimer() }}</div>
  </div>
  <div class="action-with-confirmation-text-footer">
    <div class="cancel" (click)="cancelClicked()">No</div>
    <div
      class="confirm"
      (click)="actionClicked()"
      [ngClass]="{
        'confirm-disabled': textValidationControl.invalid,
      }"
    >
      Yes
    </div>
  </div>
</div>
